import script from "./SuggestedBirthday.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestedBirthday.vue?vue&type=script&setup=true&lang=js"

import "./SuggestedBirthday.vue?vue&type=style&index=0&id=73237559&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73237559"]])

export default __exports__